'use client';

import { Button } from '@mantine/core';
import { FC, useCallback, useEffect, useState } from 'react';
import Image from 'next/image';
import { useRouter } from 'next/navigation';
import classNames from 'classnames';
import { NariPoints } from '../NariPoints/NariPoints';
import classes from './UserNariPoints.module.css';
import narilaZEHNVONZEHN from '@/assets/emotes/narilaZEHNVONZEHN.png';
import { useCreditStore } from '@/lib/providers/credit-store-provider';

export const UserNariPoints: FC = () => {
    const credits = useCreditStore(s => s.credits);
    const [gainedPoints, setGainedPoints] = useState(0);
    const [displayedPoints, setDisplayedPoints] = useState(credits);
    const router = useRouter();

    const gainPoints = useCallback((amount: number) => {
        setGainedPoints(amount);

        const t = setTimeout(() => {
            setDisplayedPoints(displayedPoints + amount);
            setGainedPoints(0);
        }, 2000);

        return () => clearTimeout(t);
    }, [displayedPoints]);

    useEffect(() => {
        if (displayedPoints === credits) return () => {};

        return gainPoints(credits - displayedPoints);
    }, [displayedPoints, credits]);

    return (
        <Button
          variant="transparent"
          color="white"
          size="md"
          onClick={() => router.push('/paypal')}
        >
            <div title="Nari-Punkte" className={classes.creditsButton}>
                <div className={classes.pointHolder}>
                    <div className={classNames(classes.currentPoints, { [classes['currentPoints-hidden']]: gainedPoints > 0 })}>
                        <NariPoints key="user-nari-points" amount={displayedPoints} fixed />
                    </div>
                    <div className={classNames(classes.gainPoints, { [classes['gainPoints-hidden']]: gainedPoints > 0 })}>
                        <NariPoints key="user-nari-points" amount={gainedPoints} fixed formattingFn={(n) => `+${n.toLocaleString()}`} />
                    </div>
                </div>
                <Image src={narilaZEHNVONZEHN.src} alt="Nari-Punkte" width={24} height={24} />
            </div>
        </Button>
    );
};
